import { z } from 'zod';

export const ShapeTypeSchema = z.enum(['RECTANGLE', 'ELLIPSE', 'TRIANGLE', 'POLYGON', 'STAR', 'ARROW', 'ICON']);
export type ShapeType = z.infer<typeof ShapeTypeSchema>;
